import { render, staticRenderFns } from "./VCard.vue?vue&type=template&id=403f6b76&"
import script from "./VCard.vue?vue&type=script&lang=js&"
export * from "./VCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports